import useDarkMode from 'use-ui-mode';
import { LuSun, LuMoon } from 'react-icons/lu';
import '../stylesheet/DarkModeToggle.css';

const DarkModeToggle = () => {
  const darkMode = useDarkMode(false);

  return (
    <button
      type="button"
      className="dark-mode-toggle"
      onClick={darkMode.toggle}
      aria-pressed={darkMode.value}
      aria-label={darkMode.value ? 'Switch to light mode' : 'Switch to dark mode'}
      title={darkMode.value ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <span className="dark-mode-toggle-icon sun">
        <LuSun />
      </span>
      <span className="dark-mode-toggle-icon moon">
        <LuMoon />
      </span>
    </button>
  );
};

export default DarkModeToggle;
